import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { PostDeliveryResultReportsDownloadParams } from '~/types/delivery-agency.types';

/**
 * [배송 결과 리포트] 목록 전체 엑셀 다운로드 API
 */
const fetchPostDeliveryResultReportsDownload = async (
  params: PostDeliveryResultReportsDownloadParams
): Promise<void> => {
  const response = await axiosInstance.post(
    API_ENDPOINT.DELIVERY_AGENCY.POST_DELIVERY_RESULT_REPORTS_DOWNLOAD,
    params,
    { responseType: 'blob' }
  );

  downloadBlobDataFile(response);
};

/**
 * [배송 결과 리포트] 목록 전체 엑셀 다운로드 Mutation Hook
 */
export const usePostDeliveryResultReportsDownloadMutation = () => {
  return useDownloadMutation(fetchPostDeliveryResultReportsDownload);
};
